import { TimeSlotHelper } from '../util/timeSlotHelper';
import { Deserializable } from './deserializable';
import { TimeSlot } from './timeSlot';
import * as moment from 'moment';
import { StringHelper } from '../util/stringHelper';
import { Log } from '../util/log';


export class PeriodicExecution implements Deserializable {

  public static OperationTypeForcedLow: string = "ForceLow";

  public static ResultIdle: string = "Idle";
  public static ResultExecuting: string = "Executing";
  public static ResultExecuted: string = "Executed";
  public static ResultError: string = "Error";

  public static ErrorCannotStop: string = "cannot stop";


  id: number;
  serial: string;
  operationType: string;
  result: string;
  timeZone : string;

  // timeMask: string;
  timeMask5min: string;
  dayMask: number;
  
  timeSlots: TimeSlot[] = [];
  daysAllowed: string = "";
  hoursAllowed: string = "";

  error: string;
  errorDescription: string;
  description: string;

  deserialize(input: any) {
    Object.assign(this, input);

    this.timeZone = moment.tz.guess();
    // this.timeSlots = TimeSlotHelper.binaryStringToTimeSlots(this.timeMask);
    this.timeSlots = TimeSlotHelper.binaryStringToTimeSlots5min(this.timeMask5min);

    if(this.result == PeriodicExecution.ResultIdle){
      this.result = $localize`:@@periodicExecutionModel_result_idle:In attesa`;
    } else if(this.result == PeriodicExecution.ResultExecuting){
      this.result = $localize`:@@periodicExecutionModel_result_executing:In esecuzione`;
    } else if(this.result == PeriodicExecution.ResultExecuted){
      this.result = $localize`:@@periodicExecutionModel_result_executed:Eseguito`;
    } else if(this.result == PeriodicExecution.ResultError){
      //aggiungere traduzioni errori

      // if(this.errorDescription == PeriodicExecution.ErrorCannotStop){
      //   this.result = $localize`:@@periodicExecutionModel_result_error:Errore` + ": " + $localize`:@@periodicExecutionModel_result_error_cannot_stop:Impossibile terminare`;
      // } else{
        //fallback errore non tradotto, da decidere se va lasciato
        this.result = $localize`:@@periodicExecutionModel_result_error:Errore` + ": " + this.errorDescription;
      // }
    }


    this.getDaysAllowed();
    this.getHoursAllowed();
    return this;
  }


  isDayAllowed(dayOfWeek: number) {
    dayOfWeek = dayOfWeek - 1;

    return (this.dayMask & (1 << dayOfWeek)) == (1 << dayOfWeek);
  }

  getDayCheckedOrNot(dayOfWeek: number) {

    if (this.isDayAllowed(dayOfWeek)) {
      return "true";
    }
    else {
      return "false";
    }
  }

  getDaysAllowed() {
    this.daysAllowed = "";
    if (this.dayMask == 127) {
      this.daysAllowed = $localize`:@@periodic_execution_everyday:Tutti i giorni`;
    } else if (this.isDayAllowed(1) && this.isDayAllowed(2) && this.isDayAllowed(3) && this.isDayAllowed(4) && this.isDayAllowed(5) && !this.isDayAllowed(6) && !this.isDayAllowed(7)) {
      this.daysAllowed = $localize`:@@periodic_execution_working_days:Giorni lavorativi (lun-ver)`;
    } else {
      if (this.isDayAllowed(1)) {
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_monday_short:lun`;
      }
      if (this.isDayAllowed(2)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_tuesday_short:mar`;
      }
      if (this.isDayAllowed(3)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_wednesday_short:mer`;
      }
      if (this.isDayAllowed(4)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_thursday_short:gio`;
      }
      if (this.isDayAllowed(5)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_friday_short:ven`;
      }
      if (this.isDayAllowed(6)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_saturday_short:sab`;
      }
      if (this.isDayAllowed(7)) {
        if (this.daysAllowed != "") {
          this.daysAllowed = this.daysAllowed + ", ";
        }
        this.daysAllowed = this.daysAllowed + $localize`:@@periodic_execution_sunday_short:dom`;
      }
      this.daysAllowed = this.daysAllowed.substr(0, 1).toUpperCase() + this.daysAllowed.substr(1);

    }
  }

  getHoursAllowed() {
    if (this.timeSlots.length == 0) {
      this.hoursAllowed = $localize`:@@periodic_execution_all_day:, Tutto il giorno`;
    } else if(this.timeSlots.length == 1) {
      this.hoursAllowed = $localize`:@@periodic_execution_time_from:Dalle` + " " + this.timeSlots[0].getFromHourMin() + " " + $localize`:@@periodic_execution_time_to: alle` + " " + this.timeSlots[0].getToHourMin();
    } else {
      this.hoursAllowed = $localize`:@@periodic_execution_time_from:Dalle` + " " + this.timeSlots[0].getFromHourMin() + " " + $localize`:@@periodic_execution_time_to: alle` + " " + this.timeSlots[0].getToHourMin();
      for (let i = 1; i < this.timeSlots.length; i++) {
        this.hoursAllowed =  this.hoursAllowed + ", " +$localize`:@@periodic_execution_time_from_lower_case:dalle` + " " + this.timeSlots[i].getFromHourMin() + " " + $localize`:@@periodic_execution_time_to: alle` + " " + this.timeSlots[i].getToHourMin();
      }
    }
  }


  public static createCopy(permission: PeriodicExecution): PeriodicExecution {

    let copyExecution: PeriodicExecution = new PeriodicExecution();

    copyExecution = Object.create(permission);

    if (!copyExecution.timeSlots) {

      // copyExecution.timeSlots = TimeSlotHelper.binaryStringToTimeSlots(
      //   copyExecution.timeMask
      // );

      copyExecution.timeSlots = TimeSlotHelper.binaryStringToTimeSlots(
        copyExecution.timeMask5min
      );

    } else {

      copyExecution.timeSlots = [];

      for (let slot of permission.timeSlots) {
        copyExecution.timeSlots.push(Object.create(slot));
      }
    }

    return copyExecution;
  }

  public static timeSlot5MinToBinaryString(timeSlot: TimeSlot) {
    let startTime: number = timeSlot.fromHour * 12;
    startTime += Math.ceil(timeSlot.fromMinutes / 5.0);

    // devo sottrarre 5 minuti
    let endTime: number = timeSlot.toHour * 12;
    if (timeSlot.toMinutes == 0) {
      endTime--;
    }

    Log.debug("startTime: " + startTime);
    Log.debug("endTime: " + endTime);

    let mask: string = "000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";

    for (let i: number = startTime; i <= endTime; i++) {
      mask = StringHelper.replaceAt(mask, i, "1");
    }

    return mask;
  }
}
